import React from "react";
import { Card, Grid } from '@mui/material';
import Title from './../ReusableComponents/title';
import LongShortTable from "./LongShortTable";
import LongShortChart from "../Charts/LongShortChart";
import LongBalanceChart from "../Charts/LongBalanceChart";
import ShortBalanceChart from "../Charts/ShortBalanceChart";

const LongShortBalance = ({data}) => {
  // <Card className="card-csc"></Card>
  return (
    <Grid item container spacing={2} className='longshort-ctn'>
      <Grid className="longshort-inner" item xs={12} md={6}  sx={{ paddingLeft: { xs: 0 } }}>
        <Card className="card-csc">
          <Title six>Long/Short Comparison</Title>
          <LongShortTable data={data && data} />
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card className="card-csc">
          <Title six>Long/Short</Title>
          <LongShortChart data={data} />
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card className="card-csc">
          <Title six>Long Balance</Title>
          <LongBalanceChart data={data.Long_chart} />
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card className="card-csc">
          <Title six>Short Balance</Title>
          <ShortBalanceChart data={data.short_chart} />
        </Card>
      </Grid>
    </Grid>
  );
};

export default LongShortBalance;
